import { $authHost } from "../../http";
import { 
    RESULT_STATE_GET_REQUEST, RESULT_STATE_GET_SUCCESS, RESULT_STATE_GET_ERROR, 
    RESULT_STATE_GET_BY_KEY_REQUEST, RESULT_STATE_GET_BY_KEY_SUCCESS, RESULT_STATE_GET_BY_KEY_ERROR, 
    RESULT_STATE_ADD_REQUEST, RESULT_STATE_ADD_SUCCESS, RESULT_STATE_ADD_ERROR, 
    RESULT_STATE_EDIT_REQUEST, RESULT_STATE_EDIT_SUCCESS, RESULT_STATE_EDIT_ERROR, 
    RESULT_STATE_DELETE_REQUEST, RESULT_STATE_DELETE_SUCCESS, RESULT_STATE_DELETE_ERROR
} from "../constants/resultStateConstants";

export const getResultStates = (args) => async (dispatch) => {
    try {
        dispatch({
            type: RESULT_STATE_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/resultState/query",
            args || {},
            config,
        );
        dispatch({
            type: RESULT_STATE_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: RESULT_STATE_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getResultStateByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: RESULT_STATE_GET_BY_KEY_REQUEST
        });

        const {data} = await $authHost.get(
            `/api/v1/resultState/${id}`,
        );
        dispatch({
            type: RESULT_STATE_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: RESULT_STATE_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addResultState = ({ name, code }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: RESULT_STATE_ADD_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.post(
            "/api/v1/resultState",
            { name, code },
            config,
        );
        dispatch(getResultStates(queryArgs || {}));
        dispatch({
            type: RESULT_STATE_ADD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: RESULT_STATE_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const editResultState = ({ id, name, code }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: RESULT_STATE_EDIT_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.put(
            "/api/v1/resultState",
            { id, name, code },
            config,
        );
        dispatch(getResultStates(queryArgs || {}));
        dispatch({
            type: RESULT_STATE_EDIT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: RESULT_STATE_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteResultState = (id, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: RESULT_STATE_DELETE_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.delete(
            "/api/v1/resultState",
            { data: { id } },
            config,
        );
        dispatch(getResultStates(queryArgs || {}));
        dispatch({
            type: RESULT_STATE_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: RESULT_STATE_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

